import React, { useEffect } from "react";
import { MdArrowForwardIos } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";

const Card = ({ item }) => {
  const Navigate = useNavigate();
   useEffect(() => {
    AOS.init();
  }, []);
  return (
    <div
    data-aos="fade-left"
      className="pt-12  w-full shadow-lg shadow-Background6 bg-gradient-to-b from-Background2 to-white rounded-ss-6xl rounded-se-2xl rounded-ee-6xl rounded-l-2xl rounded-bl-2xl cursor-pointer"
      onClick={() => {
        Navigate(`/product/${item?._id}/${item?.type}`);
      }}
    >
      <div className="flex flex-col justify-center items-center mb-4">
        <div className="w-3/4">
          <img
            src={item?.image?.location}
            className="w-full object-cover p-4"
            alt=""
          />
        </div>
        <span className="text-textColor text-lg">{item?.name}</span>
      </div>
      <div>
        <div className="flex gap-2 items-center justify-center bg-Background2 py-5 rounded-ee-6xl rounded-bl-2xl">
          <span className="text-textColor font-semibold">Explore</span>
          <MdArrowForwardIos />
        </div>
      </div>
    </div>
  );
};

export default Card;
